module.exports = __webpack_public_path__ + "img/calendar.db041557.png";